class DropdownMenu {
    constructor() {
        this.DOM = {
            body: document.body,
            menuDropdownOpenItems: document.querySelectorAll('.site-header .menu .menu-item.dropdown'),
            menuDropdownCloseItemsInMenu: document.querySelectorAll('.site-header .menu-item:not(.dropdown)'),
            menuDropdownCloseItems: document.querySelectorAll('.header-dropdown-close'),
            submenuContainers: document.querySelectorAll('.header-dropdown .submenu-container'),
            menuDropdown: document.querySelector('.header-dropdown')
        };

        this.isOpen = false;
        this.pendingHoverElement = null;

        setTimeout(() => {
            this.setEventListeners();
        }, 1000);

        // this.testOpenFirstDropdown();
    }

    testOpenFirstDropdown() {
        setTimeout(() => {
            const firstDropdownItem = this.DOM.menuDropdownOpenItems[0];
            if (firstDropdownItem) {
                this.openDropdownMenu(firstDropdownItem);
            }
        }, 200);
    }

    setEventListeners() {
        // Dropdown hovers
        this.DOM.menuDropdownOpenItems.forEach((element) => {
            element.addEventListener('mouseover', () => this.onDropdownItemHover(element));
            element.addEventListener('mouseleave', () => this.onDropdownItemHoverOut());
        });
        this.DOM.menuDropdownOpenItems.forEach((element) => {
            element.addEventListener('click', () => this.onDropdownItemClick(element));
        });
        this.DOM.menuDropdownCloseItems.forEach((element) => {
            element.addEventListener('mouseover', () => this.onDropdownItemHoverOut());
        });
        this.DOM.menuDropdownCloseItemsInMenu.forEach((element) => {
            element.addEventListener('mouseover', () => this.onDropdownItemInMenuHoverOut());
        });
        if (this.DOM.menuDropdown) {
            this.DOM.menuDropdown.addEventListener('mouseover', () => this.cancelTimeout());
        }
    }

    onDropdownItemClick(element) {
        const aElement = element.querySelector('a');
        const href = aElement.href;
        window.open(href, '_self');
    }

    onDropdownItemHover(element) {
        clearTimeout(this.dropdownTimeout);

        if (this.isOpen) {
            console.log('menu isOpen: add delay');
            this.dropdownTimeout = setTimeout(() => {
                this.openDropdownMenu(element);
            }, 500);
        } else {
            console.log('menu !isOpen: little delay, not triggered by unintented hover');
            this.pendingHoverElement = element;
            this.dropdownTimeout = setTimeout(() => {
                if (this.pendingHoverElement === element) {
                    this.openDropdownMenu(element);
                }
            }, 300);
        }
    }

    onDropdownItemHoverOut() {
        console.log('menu drop down hitarea hover out');
        clearTimeout(this.dropdownTimeout);
        this.pendingHoverElement = null;

        if (this.isOpen) {
            this.dropdownTimeout = setTimeout(() => {
                this.closeDropdownMenu();
            }, 200);
        }
    }

    onDropdownItemInMenuHoverOut() {
        console.log('menu drop down item hover out');
        clearTimeout(this.dropdownTimeout);

        this.dropdownTimeout = setTimeout(() => {
            this.closeDropdownMenu();
        }, 500);
    }

    cancelTimeout() {
        clearTimeout(this.dropdownTimeout);
        this.pendingHoverElement = null;
    }

    openDropdownMenu(element) {
        const a = element.querySelector('a');
        const dropdownKey = a.dataset.dropdownKey;

        console.log('openDropdownMenu', dropdownKey);
        this.DOM.submenuContainers.forEach((sc) => {
            sc.classList.remove('active');
        });
        const submenuContainerSelector = `.submenu-container[data-dropdown-key="${dropdownKey}"]`;
        const newSubmenuContainer = document.querySelector(submenuContainerSelector);

        if (!newSubmenuContainer) {
            console.warn('No submenu container found for key:', dropdownKey);
            return;
        }
        newSubmenuContainer.classList.add('active');

        this.isOpen = true;
        this.DOM.body.classList.add('open-dropdown');
        this.DOM.body.classList.add('show-overlay-menu');
    }

    closeDropdownMenu() {
        this.isOpen = false;
        this.DOM.body.classList.remove('open-dropdown');
        this.DOM.body.classList.remove('show-overlay-menu');
    }
}
new DropdownMenu();
